<template>
  <v-snackbar
    :value="show"
    color="error"
    :top="true"
    :multi-line="true"
    :auto-height="true"
    :timeout="6000"
    :vertical="false"
  >
    <m-pay-error-message
      :error="error"
      :component="component"
      :validationError="validationError"
      :customErrorMessage="errorMessage"
    ></m-pay-error-message>

    <v-btn dark flat @click="closeMessage">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>

import MPayErrorMessage from './MPayErrorMessage';

export default {
  name: 'MPayErrorDialog',
  components: { MPayErrorMessage },
  props: ['errorMessage', 'trigger', 'error', 'component', 'validationError'],
  data: () => ({
    show: false,
  }),
  computed: {
    value() {
      return this.error || this.validationError || this.errorMessage;
    },
  },
  methods: {
    closeMessage() {
      this.show = false;
    },
    showMessage() {
      this.closeMessage();
      // make message (if any) disappear before displaying it (again)
      this.$nextTick().then(() => { this.show = this.value; });
    },
  },
  watch: {
    value() {
      this.showMessage();
    },
    trigger() {
      this.showMessage();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MPayErrorDialog.vue